<template lang="pug">
  div
    b-card.mt-3(
      :title="fullName"
      header-tag="header"
      footer-tag="footer"
      :border-variant="saleId ? 'secondary':'primary'"
      :header-bg-variant="saleId ? 'secondary':'primary'"
      header-text-variant="white"
    )
      template(v-slot:header)
        h6(class="mb-0") {{ cardHeader }} {{ 'pasajero' | pluralize(cardHeader) }}
      b-card-text
        pre(v-if="!showForm && verbose") {{ cardContent }}
        div(v-if="showForm")
          px-form(v-if="showForm" :airports="airports" :input="false" :operation="cardContent")
      b-button(v-if="!hideButtons" :to="{ name: 'Operation', params: { id: this.id } }" :variant="saleId ? 'secondary':'primary'") {{ saleId ? "Ver venta" : "Ver reserva"}}
      b-button.ml-1(v-if="!saleId && !hideButtons" :to="{ name: 'Operation', params: { id: this.id } }" variant='secondary') Crear venta
      template(v-if="cardFooter" v-slot:footer)
        span {{ cardFooter }}
</template>

<script>
import PxForm from "@/components/PxForm.vue";

//import { mapState, mapGetters } from "vuex";

export default {
  name: "PxCard",
  components: {
    PxForm,
  },
  props: {
    id: String,
    saleId: Boolean,
    fullName: String,
    cardHeader: Number,
    cardFooter: String,
    cardContent: Object,
    hideButtons: {
      type: Boolean,
      default: false,
    },
    showForm: {
      type: Boolean,
      default: false,
    },
    airports: Array /*{
      type: Array,
      default: function () {
        return [];
      },
    },*/,
  },
  /*computed: {
    ...mapState(["airports"]),
    ...mapGetters(["airports"]),
  },*/
  data() {
    return {
      //baseUrl: process.env.VUE_APP_BASE_URL,
      verbose: this.$route.query.dev || this.$route.query.dev === null,
    };
  },
  filters: {
    pluralize: (message, value) => {
      if (!value) return "";
      return value > 1 ? message + "s" : message;
    },
  },
  /*computed: {
    ...mapState(["operations", "loading", "errored"]),
    ...mapGetters(["operations", "loading", "errored"]),
  },*/
  /*watch: {
    // call again the method if the route changes
    $route: "fetchData",
  },*/
  /*async*/
  //mounted() {
  //try {
  /*await*/ //this.$store.dispatch("loadItems");
  //console.log(this.$store.getters.operations);
  //} catch (error) {
  //console.log(error);
  //this.errored = true;
  //} finally {
  //this.loading = false;
  //}
  /*this.$store.dispatch("loadItems");
    this.operations = this.$store.operations;*/
  /*this.loading = this.$store.loading;
    this.errored = this.$store.errored;*/
  //},
  /*async mounted() {
    try {
      let response = await axios.get(this.baseUrl + "test.json");
      this.operations = response.data.operations;
      for (let i = 0; i < 4; i++) {
        this.operations[i + 1] = this.operations[0];
      }
    } catch (error) {
      console.log(error);
      this.errored = true;
    } finally {
      this.loading = false;
    }
  },
  created() {
    // Fetch Data
    /*this.fetchData((data) => {
      this.data = data;
      console.log(this.data);
    });*/
  /*this.fetchData();*/
  //},
  /*methods: {
    getOperations() {
      this.$store.commit("getOperations", this.operations);
      console.log(this.$store.state.operations);
    },
  },*/
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.card-group > div {
  width: 100%;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 2;
  }

}
</style>
